import styled from 'styled-components';

import New from '../../../New';

export const Form = styled(New)`
  padding-bottom: 0;
`;
